import React from "react";
import { useEffect, useState } from "react";
// --> Import other modules
import { PageHeader, useToast } from "../components/ds";
import { useStateContext } from "../contexts/ContextProvider";
import { useBreakpoint } from "../hooks/useBreakpoint";
import MobileDashboard from "../components/mobile/MobileDashboard";

function Dashboard() {
  const { showSearch, setActiveMenu } = useStateContext();
  const { isPhone } = useBreakpoint();

  /**-----------------------------------------------------------------------------------------------------------------------
   *                                        LEGACY WebSoc + Tech Status — REMOVED (#44 cleanup)
   *
   * A second, legacy `WebSocClient` (`class/WebSoc.js`) used to open its own socket
   * here, hardcoded to `ws://localhost:8888/websocket` — a service that no longer
   * exists in the stack. It never connected, which is why the navbar's red/green
   * status icon sat permanently RED even with the real socket healthy and streaming.
   *
   * It was also the only producer for the Tech Status / "Smart Monitoring" tile
   * (`pages/TechDash/*`, fed by Cerebro `UpdateDashboard` broadcasts), so that tile
   * had been stuck on its "data Loading..." empty state indefinitely. Client, context
   * flag, navbar icon and tile are all deleted; `WebSocketManager` is the single
   * source of truth for connection health.
   *-----------------------------------------------------------------------------------------------------------------------**/

  /**-----------------------------------------------------------------------------------------------------------------------
   *                                                    SnackBar
   *-----------------------------------------------------------------------------------------------------------------------**/

  // --> SnackBar Variables
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const [SnackbarMessage, setSnackbarMessage] = React.useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  //--> DS toast (replaces the removed MUI Snackbar). Bridge the legacy
  //    setShowSnackbar(...) triggers so every existing call-site keeps working.
  const toast = useToast();
  useEffect(() => {
    if (showSnackbar && SnackbarMessage) {
      (toast[snackbarSeverity] || toast.info)(SnackbarMessage);
      setShowSnackbar(false);
    }
  }, [showSnackbar, SnackbarMessage, snackbarSeverity, toast]);

  // Phone Home → native-feel dashboard (P&L hero + quick actions + movers).
  // The MobileHeader (AppShell) already owns the title, so no PageHeader here.
  if (isPhone) {
    return <MobileDashboard />;
  }

  return (
    <div className="min-h-screen bg-main-bg dark:bg-main-dark-bg pt-0 px-4 md:px-6 pb-10">
      {/* Standardized page header (common across all pages) */}
      <PageHeader title="Overview" subtitle="Your trading dashboard at a glance." />
    </div>
  );
}

export default Dashboard;
